import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {createCourier, updateCourier, selectCouriers} from './couriersSlice';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { checkFieldUpdate } from '../../common/utils';
import {makeStyles, withStyles} from '@material-ui/core/styles';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: '#D86D7E',
    color: '#FFF',
    '&:hover': {
      opacity: 0.9,
      backgroundColor: '#D86D7E',
    },
    width: '100%',
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  outer: {display: 'flex', flexFlow: 'column'},
  addIcon: {
    marginRight: 8,
    color: '#fff',
  },
  title: {
    color: '#fff',
    padding: 16,
    backgroundColor: ' #42494E',
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 'bold',
  },
  textItem: {
    marginBottom: 16,
  },
}));

export default function Courier(props) {
  let jwtToken = localStorage.getItem('coreToken');
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [baseURL, setBaseURL] = useState('');
  const [editCourier, setEditCourier] = useState(false);
  const [statusID, setStatusID] = useState([]);
  const [statusList, setStatusList] = useState([
    {id: 1, value: 'active'},
    {id: 2, value: 'inactive'},
    {id: 3, value: 'deleted'},
    {id: 4, value: 'unavailable'},
  ]);
  const [courierStatus, setCourierStatus] = useState('');
  const {editing, courier, couriersAmount} = useSelector(selectCouriers);
  useEffect(() => {
    if (editing && courier !== {} && courier.name !== name && courier.statusID) {
      setName(courier.name);
      setBaseURL(courier.baseURL);
      setStatusID(courier.statusID);
      setCourierStatus(statusList[courier.statusID - 1].value);
      setEditCourier(true);
      setOpen(true);
    }
  }, [courier]);

  const handleClickOpen = () => {
    setName('');
    setBaseURL('');
    setStatusID([]);
    setCourierStatus('');
    setEditCourier(false);

    setOpen(true);
  };

  const handleClose = () => {
    setName('');
    setBaseURL('');
    setStatusID([]);
    setCourierStatus('');
    setEditCourier(false);

    setOpen(false);
  };



  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusID(selectedStatus[0].id);

    setCourierStatus(event.target.value);
  };

  const handleCreate = (e) => {
    e.preventDefault()
    let courierData = {
      statusID: statusID,
      name: name,
      baseURL: baseURL,
    };

    dispatch(
      createCourier({
        courier: courierData,
        token: jwtToken,
        couriersAmount: couriersAmount
      })
    );
  };

  const handleUpdate = (e) => {
    e.preventDefault()

    const updatedCourierFields = checkFieldUpdate([{name: 'statusID', val: statusID}, {name: 'name', val: name}, {name: 'baseURL', val: baseURL}], courier)

    dispatch(
      updateCourier({
        courier: updatedCourierFields,
        token: jwtToken,
        id: courier.id,
        couriersAmount: couriersAmount
      })
    );
  };




  return (
    <div>
      <IconButton
        aria-label={editCourier ? 'edit courier' : 'add courier'}
        style={{marginLeft: 0}}
      >
        <AddCircleIcon
          style={{marginRight: 0, color: '#fff'}}
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
      <form onSubmit={editCourier ? (e) => handleUpdate(e) : (e) => handleCreate(e)} >

        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {editCourier ? 'Edit Courier' : 'Add Courier'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{paddingTop: 8, textAlign: 'center'}}>
            {editCourier ? 'Update Courier Details' : 'Enter Courier Details'}
          </DialogContentText>
          <Grid container direction="column">
            <Grid item sm>
              <TextField
                className={classes.textItem}
                defaultValue={name}
                variant="outlined"
                autoFocus
                margin="dense"
                required
                id="name"
                label="Name"
                type="name"
                fullWidth
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>{' '}
            <Grid item sm>
              <TextField
                defaultValue={baseURL}
                className={classes.textItem}
                variant="outlined"
                multiline
                rows={4}
                margin="dense"
                id="baseURL"
                label="BaseURL"
                type="baseURL"
                fullWidth
                onChange={(e) => setBaseURL(e.target.value)}
              />
            </Grid>
            <Grid item sm style={{paddingTop: 8}}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{
                  width: '100%',
                }}
              >
                <InputLabel htmlFor="outlined-status-simple" margin="dense">
                  Courier Status*
                </InputLabel>
                <Select
                  defaultValue={statusID}
                  value={courierStatus}
                  onChange={(e) => handleStatusChange(e)}
                  margin="dense"
                  label="Courier Status"
                  required
                  inputProps={{
                    name: 'status',
                    id: 'outlined-status-simple',
                  }}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="unavailable">Unavailable</MenuItem>
                  <MenuItem value="deleted">Deleted</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{paddingLeft: 24, paddingRight: 24, paddingBottom: 16}}
        >
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <ColorButton onClick={handleClose} color="primary">
                Cancel
              </ColorButton>
            </Grid>
            <Grid item sm>
              <ColorButton
              type="submit"
                // onClick={editCourier ? handleUpdate : handleCreate}
                color="secondary"
              >
                {editCourier ? 'Edit Courier' : 'Create Courier'}
              </ColorButton>

            </Grid>
          </Grid>
        </DialogActions>
      </form>
        
      </Dialog>
    </div>
  );
}
